import React from "react";
import {
  ColProps_5,
  ColProps_1,
  ColProps_8,
  ColProps_9,
  ColProps_13,
  ColProps_11,
} from "@core/utils/ColProps";
import { Grid, Paper } from "@material-ui/core";
import useStyles from "./styles";
import { MarketProvider } from "@context/MarketContext";
import CurrencySelect from "@features/Market/MainComponents/MarketHeader/CurrencySelect";
import TradeVolume from "@features/Market/MainComponents/MarketHeader/TradeVolume";
import Warnings from "@features/Market/MainComponents/MarketHeader/Warnings";
import Settings from "@features/Market/MainComponents/MarketHeader/Settings";
import MarketOrderTemplate3 from "@features/Market/MainComponents/MarketOrderTemplate3";
import MarketChart from "@features/Market/MainComponents/MarketChart";
import OrderBook from "@features/Market/MainComponents/OrderBook";
import MarketRecentTransactions from "@features/Market/MainComponents/MarketRecentTransactions";
import MarketTable from "@features/Market/MainComponents/MarketTable";

const Template3 = () => {
  const classes = useStyles();
  return (
    <MarketProvider>
      <Grid container direction="column">
        <Grid
          container
          spacing={6}
          direction="row"
          justify="space-between"
          className={classes.marginBottom}
        >
          <Grid container item {...ColProps_9}>
            <CurrencySelect />
          </Grid>
          <Grid container item {...ColProps_8}>
            <Grid container direction="row" justify="space-between">
              <Grid
                container
                item
                {...{ xs: 10, sm: 10, md: 10, lg: 10, xl: 10 }}
              >
                <TradeVolume />
              </Grid>
              <Grid container item {...ColProps_11} justify="flex-end">
                <Warnings />
              </Grid>
              <Grid container item {...ColProps_11} justify="flex-end">
                <Settings />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          spacing={6}
          direction="row"
          justify="space-between"
          className={classes.marginBottom}
        >
          <Grid container item {...ColProps_9}>
            <Paper elevation={0} className={classes.order}>
              <MarketOrderTemplate3 />
            </Paper>
          </Grid>
          <Grid container item {...ColProps_8}>
            <Paper elevation={0} className={classes.chart}>
              <MarketChart />
            </Paper>
          </Grid>
        </Grid>

        <Grid container spacing={6} direction="row" justify="space-between">
          <Grid container item {...ColProps_13}>
            <Paper elevation={0} className={classes.OrderBook}>
              <OrderBook type="column" itemsNumber={4} template={3} />
            </Paper>
          </Grid>
          <Grid container item {...ColProps_13}>
            <Paper elevation={0} className={classes.RecentTransactionsLayout}>
              <MarketRecentTransactions ListItemNumber={10} />
            </Paper>
          </Grid>
          <Grid container item {...ColProps_5}>
            <Paper elevation={0} className={classes.table}>
              <MarketTable recentMarket={false} height="305px" />
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </MarketProvider>
  );
};

export default Template3;
